import styled, { keyframes } from 'styled-components';
import { Button } from '../../design/Button';
import { Back } from '../Intro/styles';

export const Numbers = styled.div`
  position: absolute;
  z-index: 22;
  top: 35px;
  left: 50%;
  transform: translate(-50%, 0);
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 500;
  color: rgba(37,139,224,0.76);
  text-align: center;
`;

// box-shadow: 0px 0px 56px 1000px rgba(0,0,0,${(props) => (props.areaOpacity || '.8')});
export const Area = styled.div`
  position: absolute;
  z-index: 20;
  top: calc(50vh - 50px);
  left: 50%;
  transform: translate(-50%, -50%);
  height: ${(props) => (props.height || '340')}px;
  width: ${(props) => (props.width || '200')}px;
  border-radius: ${(props) => (props.width / 2 || '100')}px;
  border: ${(props) => (props.borderWidth)}px solid transparent;
  box-shadow: 0px 0px 56px 1000px rgba(255,255,255,${(props) => (props.areaOpacity || '1')});
  
  &::before{
    content: '';
    position: absolute;
    z-index: 20;
    top: ${(props) => (props.height / 2)}px;
    left: 50%;
    transform: translate(-50%, -50%);
    height: ${(props) => (props.height + 20 + props.borderWidth || '354')}px;
    width: ${(props) => (props.width + 20 + props.borderWidth || '214')}px;
    border-radius: ${(props) => ((props.width + 20 + props.borderWidth) / 2 || '107')}px;
    border: ${(props) => (props.borderWidth)}px solid ${(props) => (props.borderColor)};
  }
`;

export const LivnessButton = styled(Button)`
  position: absolute;
  z-index: 21;
  top: calc(100% - 75px);
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
`;

export const LivenessBack = styled(Back)`
  cursor: pointer;
  z-index: 23;
  font-family: Montserrat;
  padding-left: 16px;
  left: 16px;
  top: 23px;
  color: rgba(37,139,224,0.86);
  font-size: 17px;
  line-height: 22px;
`;

export const Arrow = styled.div`
  position: absolute;
  top: calc(50vh - ${(props) => ((props.areaHeight / 2 || 200) - 80)}px);
  left: 50%;
  transform: translate(-27px, -50%);
  animation: ease-out infinite 4s slideUp;
  
  @keyframes slideUp{
    0% {
      transform: translate(-27px, calc(-50% + 100px));
      opacity: 0;
    }
    50%{
      opacity: 1;
    }
    100% {
      transform: translate(-27px, -50%);
      opacity: 0;
    }
  }
`;
